<div class="loginCard">
  <div class="card border-0 px-5 py-5 py-md-0 px-md-4 ">
    <div class="card-body px-0 px-md-5">
      <div class="text-center">
        <img alt="Racebet365" src="../../../../../assets/media/logos/racebet365.png" width="270"
          class="my-5 img-fluid" />
      </div>
      <form [formGroup]="loginForm" autocomplete="off">
        <div class="form-group">
          <input id="username" class="borderInput p-inputtext-lg" type="text" formControlName="username" pInputText
            autocomplete="off" placeholder="{{ 'AUTH.INPUT.USERNAME' | translate }}" />
          <small *ngIf="isControlHasError('username', 'required')" class="text-danger">
            {{ "AUTH.VALIDATION.REQUIRED_FIELD" | translate }}</small>
          <small *ngIf="isControlHasError('username', 'minlength')" class="text-danger">
            {{ "AUTH.VALIDATION.MIN_LENGTH_FIELD" | translate }} 3</small>
          <small *ngIf="isControlHasError('username', 'maxlength')" class="text-danger">
            {{ "AUTH.VALIDATION.MAX_LENGTH_FIELD" | translate }} 100 32</small>
        </div>
        <div class="form-row mb-5 mb-md-4">
          <div class="col-12">
            <p-password name="password" formControlName="password" [toggleMask]="true" [feedback]="false"
              class="p-inputtext-lg" placeholder="{{ 'AUTH.INPUT.PASSWORD' | translate }}"></p-password>
            <small *ngIf="isControlHasError('password', 'required')" class="text-danger">
              {{ "AUTH.VALIDATION.REQUIRED_FIELD" | translate }}</small>
            <small *ngIf="isControlHasError('password', 'minlength')" class="text-danger">
              {{ "AUTH.VALIDATION.MIN_LENGTH_FIELD" | translate }} 3</small>
            <small *ngIf="isControlHasError('password', 'maxlength')" class="text-danger">
              {{ "AUTH.VALIDATION.MAX_LENGTH_FIELD" | translate }} 10</small>
          </div>
        </div>
        <div class="mt-2">
          <button class="btn btn-warning btn-md font-lg btn-block d-flex align-items-center justify-content-center mb-3"
            (click)="submit()">
            <i *ngIf="loading" class="pi pi-spin pi-spinner text-primary mr-2" style="font-size: 1.5rem"></i>
            {{ "HOME.LOGIN" | translate }}
          </button>
          <button class="btn btn-warning btn-md font-lg btn-block d-flex align-items-center justify-content-center mb-3"
          (click)="handleReChaptra()">
          {{ "ONE-CLICK REGISTRATION" | translate }}
        </button>
        <ng-container *ngIf="reChaptra" >
          <re-captcha (resolved)="resolved($event)" class="recaptcha-container" siteKey="6LeTSZ4pAAAAACyao2J3n2svBMbLPeIp11HYNW8f"></re-captcha>
        </ng-container>
        </div>
        <div class="mt-2" *ngIf="isRegist">
          <div style="display: flex; justify-content: space-between;">
            <button class="btn btn-warning btn-md font-lg btn-block d-flex align-items-center justify-content-center m-0"
              (click)="saveToFile()">
              {{ "Save To File" | translate | uppercase }}
            </button>
            <button
              class="btn btn-warning btn-md font-lg btn-block d-flex align-items-center justify-content-center m-0 ml-1"
              (click)="saveToImage()">
              {{ "Save To Picture" | translate | uppercase}}
            </button>
          </div>
          <hr>
          <button
            class="col-12 btn btn-success btn-md font-lg btn-block d-flex align-items-center justify-content-center"
            (click)="deposit()">
            {{ "Deposit" | translate | uppercase}}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
